import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TrackOrderApiServices {
    private apiUrl: string;
    private api_server: string;
    private apiUrl2: string;
    private connectUrl: string;
    private paymentApiUrl: string;
    private sfxWebsiteBackendApi: string;

    constructor(private http: HttpClient, private activeRoute: ActivatedRoute
    ) {
        this.apiUrl = environment.apiUrl; /** Saruman URL with webApp */
        this.api_server = environment.api_server; /** Saruman URL without webApp */
        this.apiUrl2 = environment.apiUrl2; /** Figwit URL for razor pay  */
        this.connectUrl = environment.connectUrl; /** Conenct k8 URLs */
        this.paymentApiUrl = environment.paymentApiUrl; /** Saruman URL for New Payment */
        this.sfxWebsiteBackendApi = environment.sfxWebsiteBackend; /** SFX Website Backend URL */  
    }

    getOrderIdAndRequestType(requestType: any) {
        this.apiUrl = environment.apiUrl;
        if (requestType === "Fwd") {
            this.apiUrl + '/delivery';
        }
        if (requestType === "Rev") {
            this.apiUrl + '/pickup';
        }
        if (requestType === "Fwd") {
            if (this.apiUrl.indexOf('delivery') == -1) {
                this.apiUrl = this.apiUrl + 'delivery';
            }
        }
        if (requestType === "Rev") {
            if (this.apiUrl.indexOf('pickup') == -1) {
                this.apiUrl = this.apiUrl + 'pickup';
            }
        }
        return this.apiUrl;
    }


    getAwbNumber(routeData: any) {
        let url = this.api_server + `web_app/delivery/awb_unique_code/${routeData.order_id}/`;
        return this.http.get(`${url}`);
    }

    getTokenUsingSecretKey(routeData:any) {
        let url = this.api_server + `awb/awb_to_secret_key/${routeData.secret_key}/?unique_code=${routeData.order_id}`;
        return this.http.get(`${url}`);
    }

    getLorTrackDetails(routeData: any) {
        let url = this.connectUrl + `connect/lor_tracking/${routeData.order_id}/`;
        return this.http.get(`${url}`);
    }

    getTrackDetails(routeData: any) {
        let url = this.api_server + `web_app/delivery/track/${routeData.awb_number}/`;
        return this.http.get(`${url}`);
    }
    
    getCustomerInfo(routeData: any) {
        let url = this.api_server + `web_app/delivery/customer_info/${routeData.awb_number}/`;
        return this.http.get(`${url}`);
    }

	getMapDetails(params:any){
		return this.http.get(`${this.api_server}web_app/delivery/map_details/`, {params});
	}

	getHeaderMessages(): Observable<any> {
        return this.http.get(`${this.sfxWebsiteBackendApi}api/shadowfax/config/header-msg`);
	}

}

